import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtentiService } from './utenti.service';
import { Utente } from 'src/app/models/utente';
import { Permessi } from 'src/app/models/permessi';
import { ParametriLogin } from 'src/app/models/parametri-login';
import moment from 'moment';

export const TOKEN_STORAGE_KEY = 'ildato.ArticoliDpi-token';
export const LOCAL_IP_KEY = 'LOCAL_IP';
export const UTENTE_STORAGE_KEY = 'ildato.ArticoliDpi-utente';
export const TOKEN_EXPIRATION_STORAGE_KEY = 'ildato.ArticoliDpi-expiration';
export const TOKEN_EXP_TIME_STORAGE_KEY = 'ildato.ArticoliDpi-token-exp-time';
export const PARAMETRI_STORAGE_KEY = 'ildato.ArticoliDpi-parametri';
export const PERMESSI_STORAGE_KEY = 'ildato.ArticoliDpi-permessi';
export const PARAMETRI_LOGIN_STORAGE_KEY = 'ildato.ArticoliDpi-parametri-login';


@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private us = inject(UtentiService);


  private tokenSubject = new BehaviorSubject<string>(undefined);
  private tokenExpTimeSubject = new BehaviorSubject<moment.Moment>(undefined);
  private userSubject = new BehaviorSubject<Utente>(undefined);
  private expirationSubject = new BehaviorSubject<string>(undefined);
  private permessiSubject = new BehaviorSubject<Permessi[]>(undefined);
  private parametriLoginSubject = new BehaviorSubject<ParametriLogin>(undefined);
  private parametriSubject = new BehaviorSubject<any>(undefined);

  get currentToken(): string {
    if (localStorage.getItem(TOKEN_STORAGE_KEY)) {
      return localStorage.getItem(TOKEN_STORAGE_KEY);
    } else {
      return undefined;
    }
  }

  get currentTokenExpiration(): string {
    if (localStorage.getItem(TOKEN_EXPIRATION_STORAGE_KEY)) {
      return localStorage.getItem(TOKEN_EXPIRATION_STORAGE_KEY);
    } else {
      return undefined;
    }
  }

  get tokenChanged(): Observable<string> {
    return this.tokenSubject.asObservable();
  }

  get localIp(): string {
    return sessionStorage.getItem(LOCAL_IP_KEY);
  }

  setCurrentToken(token: string) {
    //console.log(`saving token ${token}`);
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
    this.tokenSubject.next(token);
  }

  setCurrentTokenExpiration(expirationTime: moment.Moment) {
    //console.log(`saving token ${token}`);
    console.log('expiration time : ' + expirationTime);
    localStorage.setItem(TOKEN_EXP_TIME_STORAGE_KEY, expirationTime.valueOf().toString());
    this.tokenExpTimeSubject.next(expirationTime);
  }

  get currentTokenExpTime(): moment.Moment {
    if (localStorage.getItem(TOKEN_EXP_TIME_STORAGE_KEY)) {
      return moment(Number(localStorage.getItem(TOKEN_EXP_TIME_STORAGE_KEY)));
    } else {
      return undefined;
    }
  }

  setCurrentExpiration(expiration:string) {
    localStorage.setItem(TOKEN_EXPIRATION_STORAGE_KEY, expiration);
    this.expirationSubject.next(expiration);
  }


  provideStorageTokenAsNextToken() {
    this.tokenSubject.next(this.currentToken);
    this.userSubject.next(this.utenteCorrente);
    this.parametriSubject.next(this.parametriCorrente);
  }  

  removeCurrentUser() {
    //console.log(`clearing token`);
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(UTENTE_STORAGE_KEY);
    localStorage.removeItem(TOKEN_EXP_TIME_STORAGE_KEY);
    sessionStorage.removeItem(PARAMETRI_STORAGE_KEY);
    localStorage.removeItem(PARAMETRI_LOGIN_STORAGE_KEY);
  }

  get utenteCorrente(): Utente {
    if (localStorage.getItem(UTENTE_STORAGE_KEY)) {
      return JSON.parse(localStorage.getItem(UTENTE_STORAGE_KEY));
    } else {
      return undefined;
    }
  }

  get utenteAggiornato(): Observable<Utente> {
    return this.userSubject.asObservable();
  }


  setCurrentParametri(parametri: any) {
    sessionStorage.setItem(PARAMETRI_STORAGE_KEY, JSON.stringify(parametri));
    this.parametriSubject.next(parametri);
  }

  get parametriCorrente(): any {
    if (sessionStorage.getItem(PARAMETRI_STORAGE_KEY)) {
      return JSON.parse(sessionStorage.getItem(PARAMETRI_STORAGE_KEY));
    } else {
      return undefined;
    }
  }

  get parametriAggiornato(): Observable<any> {
    return this.parametriSubject.asObservable();
  }


  setCurrentUtente(user: Utente) {
    console.log(`Saving utente ${user?.username}`);
    localStorage.setItem(UTENTE_STORAGE_KEY, JSON.stringify(user));
    this.userSubject.next(user);
  }

  get permessiCorrente(): Permessi[] {
    if (localStorage.getItem(PERMESSI_STORAGE_KEY)) {
      return JSON.parse(localStorage.getItem(PERMESSI_STORAGE_KEY));
    } else {
      return undefined;
    }
  }

  get permessiAggiornato(): BehaviorSubject<Permessi[]> {
    return this.permessiSubject;
  }

  setCurrentPermessi(permessi: Permessi[]) {
    console.log(`Saving permessi ${permessi.length}`);
    localStorage.setItem(PERMESSI_STORAGE_KEY, JSON.stringify(permessi));
    this.permessiSubject.next(permessi);
  }

  get paramLoginCorrente(): ParametriLogin {
    if (localStorage.getItem(PARAMETRI_LOGIN_STORAGE_KEY)) {
      return JSON.parse(localStorage.getItem(PARAMETRI_LOGIN_STORAGE_KEY));
    } else {
      return undefined;
    }
  }

  get paramLoginAggiornato(): BehaviorSubject<ParametriLogin> {
    return this.parametriLoginSubject;
  }

  setCurrentParametriLogin(params: ParametriLogin) {
    console.log(`Saving parametri login ${JSON.stringify(params)}`);
    localStorage.setItem(PARAMETRI_LOGIN_STORAGE_KEY, JSON.stringify(params));
    this.parametriLoginSubject.next(params);
  }

}
